import dynamic from 'next/dynamic'
import React from 'react'

import { Box, Divider, Grid } from '@material-ui/core'

import SimpleCard from '~/components/cards/SimpleCard'
import { Title } from '~/components/shared/Text'

import SearchToolBox from '../../SearchToolBox'

import SearchFilterList from './DesktopFiltersList'

const SearchFiltersChips = dynamic(() => import('../SearchFiltersChips'), {
  ssr: false
})
const SavedSearchButton = dynamic(
  () => import('~/components/buttons/SavedSearchButton'),
  { ssr: false }
)

type Props = {
  logged: boolean
  change: (field: string, value: any) => void
}

const DesktopFiltersIndex = ({ logged, change }: Props) => {
  return (
    <Box>
      <SearchToolBox>{logged && <SavedSearchButton />}</SearchToolBox>
      <Grid container spacing={3}>
        <SearchFiltersChips
          renderWrapper={({ children, items }) => (
            <>
              {!!items.length && (
                <Grid item xs={12}>
                  <SimpleCard width="100%">{children}</SimpleCard>
                </Grid>
              )}
            </>
          )}
        />
        <Grid item xs={12}>
          <SimpleCard width="100%" p={0}>
            <Box px={2} pt={2}>
              <Title m={0} mb={2} variant="h3">
                Filters
              </Title>
              <Divider />
            </Box>
            <SearchFilterList change={change} />
          </SimpleCard>
        </Grid>
      </Grid>
    </Box>
  )
}

export default DesktopFiltersIndex
